import { makeStyles } from '@mui/styles';

const buttonBaseStyle = {
  padding: '12px 20px',
  fontSize: '1.6rem',
  fontWeight: 400,
  lineHeight: '150%',
  letterSpacing: 0.64,
};

const useStyles = makeStyles(() => ({
  button: {
    '&.MuiButton-root': {
      ...buttonBaseStyle,
    },
  },
  buttonCancel: {
    '&.MuiButton-root': {
      ...buttonBaseStyle,
      padding: '10px 20px',
    },
  },
  wrapBoxSendCer: {
    display: 'flex',
    padding: 24,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: 12,
    border: '1px solid var(--grey-2, #F5F5F5)',
    background: 'white',
    boxShadow: '0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
  },
}));

export default useStyles;
